export default __webpack_public_path__ + "static/media/banner-doctor-1.01516e30.png";